import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../services/axios/axiosInstance";
import { API_BASE_URL, getDefaultHeaders } from "../../../services/config";
import {
  fetchGeneralSettingsOverOtherScheme,
  syncHttpAccessFromSettings,
} from "../../../services/httpAccess";

export const fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}/admin/get-general-setting`,
        { headers: { ...getDefaultHeaders() } },
      );
      const settings = response?.data?.data;
      if (!settings || typeof settings !== "object") {
        return {};
      }
      syncHttpAccessFromSettings(settings);
      return settings;
    } catch (error) {
      if (!error.response) {
        const fallback = await fetchGeneralSettingsOverOtherScheme();
        if (fallback && typeof fallback === "object") {
          syncHttpAccessFromSettings(fallback);
          return fallback;
        }
      }
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch settings.",
      );
    }
  },
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    data: null,
    workflow_theme_logo: "",
    workflow_color: "",
    logo_watermark: "",
    invoice_prefix: "",
    is_dark_icons: false,
    is_android_maintenance: false,
    is_under_maintenance: false,
    is_nafath: false,
    workflow_theme_logo_base64: "",
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        const payload =
          action.payload && typeof action.payload === "object"
            ? action.payload
            : {};
        state.status = "succeeded";
        state.data = payload;
        state.error = null;
        state.workflow_theme_logo = payload.workflow_theme_logo || "";
        state.workflow_color = payload.workflow_color || "";
        state.logo_watermark = payload.logo_watermark || "";
        state.invoice_prefix = payload.invoice_prefix || "";
        state.is_dark_icons = payload.is_dark_icons || false;
        state.is_android_maintenance =
          payload.is_android_maintenance || false;
        state.is_under_maintenance = payload.is_under_maintenance || false;
        state.is_nafath = payload.is_nafath || false;
        state.workflow_theme_logo_base64 =
          payload.workflow_theme_logo_base64 || "";
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default settingsSlice.reducer;
